import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'nextPaymentTranslation',
})
export class NextPaymentTranslationPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(endDate: Date | string, startDate: Date | string = new Date()): string {
    if (!endDate) {
      return '';
    }
    const days = moment(endDate).diff(moment(startDate), 'days');
    if (days <= 0) {
      return this.translateService.instant('Next payment today');
    } else if (days === 1) {
      return this.translateService.instant('Next payment in {{remainingDays}} day', {
        remainingDays: 1,
      });
    } else {
      return this.translateService.instant('Next payment in {{remainingDays}} days', {
        remainingDays: days,
      });
    }
  }
}
